import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

const featuredVideos = [
  { id: "SfsotLUQde0", title: "US Army Battleground Recap" },
  { id: "GCcQH0qP0SQ", title: "Metro City Kumite Recap" },
  { id: "JO5b4eYqhEs", title: "School Wars Recap" },
];

const tvShowVideos = [
  { id: "IynmdYtjej0", title: "The Show · Apex Legends" },
  { id: "T4yjb2MLdqE", title: "The Show · Guilty Gear" },
  { id: "42u_fgtZWzE", title: "The Show · Dominik Mysterio y WWE2K" },
];

const partnerLogos = [
  { src: "/Logo_Monster_Energy (1).webp", alt: "Monster Energy", className: "h-7" },
  { src: "/Coca-Cola_logo.svg.png", alt: "Coca-Cola", className: "h-7" },
  { src: "/Dominos_pizza_logo.svg.png", alt: "Domino's Pizza", className: "h-8" },
  { src: "/army.png", alt: "US Army", className: "h-9" },
  { src: "/wwe.png", alt: "WWE", className: "h-9" },
  { src: "/MTV_New_Official_Logo_2021.png", alt: "MTV", className: "h-8" },
  { src: "/VH1_logonew.svg.png", alt: "VH1", className: "h-8" },
  { src: "/wipr.png", alt: "WIPR", className: "h-8" },
  { src: "/PRTV.png", alt: "PRTV+", className: "h-8" },
  { src: "/nba.png", alt: "NBA", className: "h-9" },
  { src: "/2K_Sports (1).svg", alt: "2K Sports", className: "h-8" },
  { src: "/EA-Sports-Logo-2005.png", alt: "EA Sports", className: "h-8" },
  { src: "/Microsoft_logo_(2012).svg.png", alt: "Microsoft", className: "h-6" },
  { src: "/holsum_logo_no_copyright-5254df3ef43833086d754021bc286de4.png", alt: "Holsum", className: "h-7" },
  { src: "/Colombina_Logo_2x_9fffec22-93be-4984-a2b2-5b7b9f0547aa.webp", alt: "Colombina", className: "h-7" },
  { src: "/METRO-PUERTO-RICO-1.png", alt: "Metro Puerto Rico", className: "h-7" },
  { src: "/prcc.png", alt: "Puerto Rico Comic Con", className: "h-9" },
  { src: "/Distrito_T-Mobile_Logo.png", alt: "Distrito T-Mobile", className: "h-8" },
];

const affiliationLogos = [
  {
    name: "PAMESCO",
    src: "/affiliations/pamesco-logo.png",
    href: "http://pamesco.org/portal/",
    fallback: "PAMESCO",
    className: "h-10 md:h-[3.1rem]",
    imageClassName: "opacity-100 max-w-[220px]",
  },
  {
    name: "WESCO",
    src: "/affiliations/wesco-logo.png",
    href: "https://wesco.gg/",
    fallback: "WESCO",
    className: "h-10 md:h-[3rem]",
    imageClassName: "opacity-100 max-w-[216px]",
  },
  {
    name: "International Esports Federation",
    src: "/affiliations/iesf-logo.png",
    href: "https://iesf.org/",
    fallback: "International Esports Federation",
    className: "h-9 md:h-[2.55rem]",
    imageClassName: "opacity-100 max-w-[198px]",
  },
];

const homeCopy = {
  es: {
    meta: {
      title: "Puerto Rico Esports League | Esports y entretenimiento en Puerto Rico",
      description:
        "Puerto Rico Esports League (PREL) es una plataforma de esports, entretenimiento e industria gaming en Puerto Rico que combina eventos en vivo, contenido original, televisión y alianzas de marca.",
      keywords:
        "Puerto Rico esports, esports Puerto Rico, gaming Puerto Rico, industria gaming Puerto Rico, entretenimiento gaming Puerto Rico, liga de esports Puerto Rico, eventos gaming Puerto Rico, Puerto Rico Esports League, PREL",
      ogDescription:
        "PREL conecta esports, entretenimiento, televisión, eventos en vivo e industria gaming desde Puerto Rico con visión regional e internacional.",
      locale: "es_PR",
      organizationDescription:
        "Puerto Rico Esports League es una plataforma de esports, entretenimiento e industria gaming en Puerto Rico que produce contenido original, eventos en vivo y programación televisiva.",
      webpageName: "Puerto Rico Esports League | Esports, entretenimiento e industria gaming en Puerto Rico",
    },
    hero: {
      eyebrow: "Puerto Rico Esports League",
      title: "La plataforma de esports y entretenimiento de Puerto Rico.",
      body:
        "PREL combina televisión, eventos en vivo, contenido original y cultura competitiva para conectar audiencias, marcas e instituciones desde Puerto Rico con visión de crecimiento regional e internacional.",
      ctaContent: "Ver contenido",
      ctaPartners: "Para aliados",
      ctaAbout: "Conócenos",
    },
    snapshot: {
      eyebrow: "Snapshot",
      title: "¿Qué es Puerto Rico Esports League?",
      intro:
        "Puerto Rico Esports League (PREL) es una plataforma de esports y entretenimiento en Puerto Rico que produce eventos en vivo, contenido original, activaciones de marca y programación televisiva para audiencias, jugadores, instituciones y socios comerciales.",
      body:
        "PREL nació en Puerto Rico, pero su ambición no se limita al mercado local. Estamos construyendo una propiedad mediática y de entretenimiento que integra esports, televisión, experiencias en vivo y narrativa de marca para audiencias de Puerto Rico, el mercado hispano en Estados Unidos y Latinoamérica.",
      metrics: [
        { value: "100K+", label: "Suscriptores y comunidad social" },
        { value: "20M+", label: "Impresiones digitales" },
        { value: "25%", label: "Interacción" },
        { value: "~10", label: "Puntos de rating por programa" },
      ],
      note:
        "En Puerto Rico, un desempeño cercano a 10 puntos de rating por programa en un canal local representa una señal fuerte de tracción, especialmente para un formato independiente de gaming y esports como Puerto Rico Esports League.",
    },
    events: {
      eyebrow: "Calendario",
      title: "Próximos Eventos",
      all: "Ver todos",
      details: "Ver detalles",
      items: [
        {
          slug: "plaza-carolina-comic-blast-2026",
          title: "PLAZA CAROLINA COMIC BLAST",
          date: "5 y 6 de septiembre de 2026",
          game: "Gaming Event",
          venue: "Plaza Carolina, Puerto Rico",
          status: "soon",
          href: "/plaza-carolina-comic-blast/",
          logo: "/plaza-carolina-comic-blast/comic-blast-logo-public.png",
          logoAlt: "Plaza Carolina Comic Blast",
          logoClassName: "h-16 object-contain opacity-95",
        },
        {
          slug: "veteran-series-2026",
          title: "VETERAN SERIES",
          date: "26 de septiembre de 2026",
          game: "Esports",
          venue: "Caguas, Puerto Rico",
          status: "soon",
          href: "/veteranseries/",
          logo: "/landing-logos/veteran-series-logo.png",
          logoAlt: "Veteran Series",
          logoClassName: "h-16 object-contain opacity-95",
        },
        {
          slug: "clash-of-classes-2026",
          title: "CLASH OF CLASSES",
          date: "29 de septiembre de 2026",
          game: "Rocket League",
          venue: "C3Tec, Caguas, Puerto Rico",
          status: "soon",
          href: "/clash-of-classes/",
          logo: "/clash-of-classes/clash-of-classes-logo.png",
          logoAlt: "Clash of Classes",
          logoClassName: "h-16 object-contain opacity-95",
        },
      ],
    },
    content: {
      eyebrow: "Contenido",
      title: "Contenido que deja huella",
      caption: "Recaps + contenido oficial",
    },
    show: {
      title: "Puerto Rico Esports League: The Show",
      cta: "Ver en WIPR (sitio oficial)",
      ctaAria: "Ver The Show en el sitio oficial de WIPR",
      body:
        "Programa oficial de televisión de Puerto Rico Esports League con 48 episodios, enfocado en cultura competitiva, talento local y cobertura de eventos con formato televisivo.",
    },
    gallery: {
      eyebrow: "Galería",
      title: "Así se vive la liga",
      caption: "Momentos reales de nuestros eventos",
      items: [
        { src: "/league-photos/league-01.jpg", title: "Arena y fanbase PREL" },
        { src: "/league-photos/league-02.jpg", title: "Producción televisiva en acción" },
        { src: "/league-photos/IMG_5796.jpg", title: "Talento local competitivo", objectPosition: "center 22%" },
        { src: "/league-photos/league-04.jpg", title: "Producción y contenido en vivo" },
        { src: "/league-photos/league-05.jpg", title: "Comunidad y energía de liga" },
        { src: "/media-fotos/distrito-esports-broadcast.jpg", title: "Broadcast y competición en vivo", objectPosition: "center center" },
        { src: "/league-photos/league-06.jpg", title: "Experiencia oficial PREL" },
      ],
    },
    impact: {
      eyebrow: "Impacto",
      title: "Ecosistema y eventos pasados",
      ecosystemTitle: "Impacto y ecosistema",
      ecosystemBody:
        "PREL opera en la intersección de gaming, entretenimiento, comunidad y media. No somos solo torneos: somos una plataforma donde convergen producción audiovisual, experiencias en vivo, desarrollo de audiencia y oportunidades de colaboración para marcas e instituciones.",
      bullets: [
        "Contenido original con formato broadcast y distribución digital",
        "Eventos competitivos y activaciones presenciales con ejecución profesional",
        "Integración de marcas, instituciones y aliados dentro de experiencias culturalmente relevantes",
      ],
      pastTitle: "Eventos Pasados",
      highlights: [
        { title: "US Army Battleground", desc: "Producción de torneo presencial con cobertura digital y recap audiovisual." },
        { title: "School Wars", desc: "Programa competitivo estudiantil con enfoque en talento emergente." },
        { title: "Metro City Kumite", desc: "Evento FGC con activaciones de marca y alta asistencia." },
      ],
    },
    affiliations: {
      eyebrow: "Afiliaciones internacionales",
      title: "PREL en el ecosistema global de esports",
      body:
        "Puerto Rico Esports League mantiene afiliaciones y relaciones institucionales con organismos internacionales que promueven el desarrollo, la representación y la integración de los esports a nivel regional y global.",
    },
    partners: {
      eyebrow: "Aliados",
      title: "Marcas que creen en nosotros",
      cta: "Ver página de aliados →",
    },
    faq: {
      eyebrow: "FAQ rápida",
      title: "Puerto Rico Esports League",
      cta: "Ver FAQ completa →",
      items: [
        {
          q: "¿Qué es Puerto Rico Esports League?",
          a: "Puerto Rico Esports League (PREL) es una plataforma de esports y entretenimiento en Puerto Rico que produce eventos en vivo, contenido original y programación televisiva para audiencias, marcas e instituciones.",
        },
        {
          q: "¿Qué hace diferente a PREL dentro del ecosistema de esports de Puerto Rico?",
          a: "PREL combina torneos, activaciones presenciales, televisión, video digital y alianzas estratégicas en una sola plataforma, en lugar de operar únicamente como organizador de competencias.",
        },
        {
          q: "¿PREL trabaja con marcas, medios e instituciones?",
          a: "Sí. PREL desarrolla auspicios, contenido de marca, activaciones en eventos, colaboraciones institucionales y oportunidades de visibilidad para marcas y aliados estratégicos.",
        },
        {
          q: "¿Dónde opera Puerto Rico Esports League?",
          a: "PREL nace y opera desde Puerto Rico, con una visión de crecimiento hacia el mercado hispano de Estados Unidos y Latinoamérica a través de contenido, eventos y colaboraciones.",
        },
      ],
    },
    nextStep: {
      eyebrow: "Siguiente paso",
      title: "¿Quieres participar o colaborar con PREL?",
      body: "Cuéntanos tu interés y te guiamos al formato correcto (evento, alianza, prensa o proyecto).",
      cta: "Hablar con el equipo",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Solicitudes Comerciales y Estratégicas",
      body:
        "Para auspicios, prensa, activaciones, colaboraciones o conversaciones estratégicas, utiliza este formulario y el equipo de PREL canalizará tu solicitud al área correcta.",
      validation: "Completa nombre, email, tipo de solicitud y mensaje.",
      success: "✅ Gracias. Recibimos tu solicitud y te contactaremos pronto.",
      error: "❌ No se pudo enviar. Intenta nuevamente en unos minutos.",
      submitError: "No se pudo enviar el formulario",
      placeholders: {
        name: "Nombre",
        email: "Email",
        phone: "Teléfono",
        company: "Empresa / Organización",
        message: "Cuéntanos sobre tu oportunidad, meta o solicitud",
      },
      reasonOptions: [
        "Auspicio / alianza de marca",
        "Prensa / Media",
        "Activación en Evento",
        "Alianza Estratégica",
        "Contenido / Producción",
        "Consulta General",
      ],
      sending: "Enviando...",
      submit: "Enviar solicitud",
    },
  },
  en: {
    meta: {
      title: "Puerto Rico Esports League | Esports and entertainment in Puerto Rico",
      description:
        "Puerto Rico Esports League (PREL) is an esports, entertainment, and gaming industry platform in Puerto Rico that combines live events, original content, television, and brand partnerships.",
      keywords:
        "Puerto Rico esports, esports in Puerto Rico, gaming Puerto Rico, Puerto Rico gaming industry, esports league Puerto Rico, gaming events Puerto Rico, Puerto Rico Esports League, PREL",
      ogDescription:
        "PREL connects esports, entertainment, television, live events, and gaming culture from Puerto Rico with regional and international ambition.",
      locale: "en_US",
      organizationDescription:
        "Puerto Rico Esports League is an esports, entertainment, and gaming industry platform in Puerto Rico that produces original content, live events, and television programming.",
      webpageName: "Puerto Rico Esports League | Esports and entertainment in Puerto Rico",
    },
    hero: {
      eyebrow: "Puerto Rico Esports League",
      title: "Puerto Rico's esports and entertainment platform.",
      body:
        "PREL blends television, live events, original content, and competitive culture to connect audiences, brands, and institutions from Puerto Rico with regional and international growth in mind.",
      ctaContent: "Explore content",
      ctaPartners: "For partners",
      ctaAbout: "Meet PREL",
    },
    snapshot: {
      eyebrow: "Snapshot",
      title: "What is Puerto Rico Esports League?",
      intro:
        "Puerto Rico Esports League (PREL) is an esports and entertainment platform in Puerto Rico that produces live events, original content, brand activations, and television programming for audiences, players, institutions, and commercial partners.",
      body:
        "PREL was born in Puerto Rico, but its ambition goes beyond the local market. We are building a media and entertainment property that integrates esports, television, live experiences, and brand storytelling for Puerto Rico, the U.S. Hispanic market, and Latin America.",
      metrics: [
        { value: "100K+", label: "Subscribers and social community" },
        { value: "20M+", label: "Digital impressions" },
        { value: "25%", label: "Engagement" },
        { value: "~10", label: "TV rating points per show" },
      ],
      note:
        "In Puerto Rico, performance close to 10 rating points per show on a local channel signals strong traction, especially for an independent gaming and esports format like Puerto Rico Esports League.",
    },
    events: {
      eyebrow: "Calendar",
      title: "Upcoming Events",
      all: "View all",
      details: "View details",
      items: [
        {
          slug: "plaza-carolina-comic-blast-2026",
          title: "PLAZA CAROLINA COMIC BLAST",
          date: "September 5 and 6, 2026",
          game: "Gaming Event",
          venue: "Plaza Carolina, Puerto Rico",
          status: "soon",
          href: "/plaza-carolina-comic-blast/",
          logo: "/plaza-carolina-comic-blast/comic-blast-logo-public.png",
          logoAlt: "Plaza Carolina Comic Blast",
          logoClassName: "h-16 object-contain opacity-95",
        },
        {
          slug: "veteran-series-2026",
          title: "VETERAN SERIES",
          date: "September 26, 2026",
          game: "Esports",
          venue: "Caguas, Puerto Rico",
          status: "soon",
          href: "/veteranseries/",
          logo: "/landing-logos/veteran-series-logo.png",
          logoAlt: "Veteran Series",
          logoClassName: "h-16 object-contain opacity-95",
        },
        {
          slug: "clash-of-classes-2026",
          title: "CLASH OF CLASSES",
          date: "September 29, 2026",
          game: "Rocket League",
          venue: "C3Tec, Caguas, Puerto Rico",
          status: "soon",
          href: "/clash-of-classes/",
          logo: "/clash-of-classes/clash-of-classes-logo.png",
          logoAlt: "Clash of Classes",
          logoClassName: "h-16 object-contain opacity-95",
        },
      ],
    },
    content: {
      eyebrow: "Content",
      title: "Content that leaves a mark",
      caption: "Recaps + official content",
    },
    show: {
      title: "Puerto Rico Esports League: The Show",
      cta: "Watch on WIPR (official site)",
      ctaAria: "Watch The Show on the official WIPR website",
      body:
        "Puerto Rico Esports League's official television show with 48 episodes focused on competitive culture, local talent, and event coverage in a true broadcast format.",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "What the league feels like",
      caption: "Real moments from our events",
      items: [
        { src: "/league-photos/league-01.jpg", title: "PREL arena and fanbase" },
        { src: "/league-photos/league-02.jpg", title: "Television production in action" },
        { src: "/league-photos/IMG_5796.jpg", title: "Local competitive talent", objectPosition: "center 22%" },
        { src: "/league-photos/league-04.jpg", title: "Production and live content" },
        { src: "/league-photos/league-05.jpg", title: "Community and league energy" },
        { src: "/media-fotos/distrito-esports-broadcast.jpg", title: "Broadcast and live competition", objectPosition: "center center" },
        { src: "/league-photos/league-06.jpg", title: "Official PREL experience" },
      ],
    },
    impact: {
      eyebrow: "Impact",
      title: "Ecosystem and past events",
      ecosystemTitle: "Impact and ecosystem",
      ecosystemBody:
        "PREL operates at the intersection of gaming, entertainment, community, and media. We are not just tournaments: we are a platform where audiovisual production, live experiences, audience development, and collaboration opportunities for brands and institutions come together.",
      bullets: [
        "Original content with broadcast-style production and digital distribution",
        "Competitive events and on-site activations executed professionally",
        "Integration of brands, institutions, and partners into culturally relevant experiences",
      ],
      pastTitle: "Past Events",
      highlights: [
        { title: "US Army Battleground", desc: "In-person tournament production with digital coverage and audiovisual recap." },
        { title: "School Wars", desc: "Student competition program focused on emerging talent." },
        { title: "Metro City Kumite", desc: "FGC event with brand activations and strong attendance." },
      ],
    },
    affiliations: {
      eyebrow: "International affiliations",
      title: "PREL in the global esports ecosystem",
      body:
        "Puerto Rico Esports League maintains affiliations and institutional relationships with international organizations that promote development, representation, and integration of esports at the regional and global level.",
    },
    partners: {
      eyebrow: "Partners",
      title: "Brands that believe in us",
      cta: "View partners page →",
    },
    faq: {
      eyebrow: "Quick FAQ",
      title: "Puerto Rico Esports League",
      cta: "View full FAQ →",
      items: [
        {
          q: "What is Puerto Rico Esports League?",
          a: "Puerto Rico Esports League (PREL) is an esports and entertainment platform in Puerto Rico that produces live events, original content, and television programming for audiences, brands, and institutions.",
        },
        {
          q: "What makes PREL different within Puerto Rico's esports ecosystem?",
          a: "PREL combines tournaments, on-site activations, television, digital video, and strategic partnerships in a single platform rather than operating only as a competition organizer.",
        },
        {
          q: "Does PREL work with brands, media, and institutions?",
          a: "Yes. PREL develops sponsorships, branded content, event activations, institutional collaborations, and visibility opportunities for brands and strategic partners.",
        },
        {
          q: "Where does Puerto Rico Esports League operate?",
          a: "PREL was born in Puerto Rico and operates from the island, with a growth vision toward the U.S. Hispanic market and Latin America through content, events, and collaborations.",
        },
      ],
    },
    nextStep: {
      eyebrow: "Next step",
      title: "Want to compete or collaborate with PREL?",
      body: "Tell us what you're looking for and we'll guide you to the right format for your event, partnership, press, or project.",
      cta: "Talk to the team",
    },
    contact: {
      eyebrow: "Contact",
      title: "Commercial and Strategic Inquiries",
      body:
        "For sponsorships, press, activations, collaborations, or strategic conversations, use this form and the PREL team will route your inquiry to the right area.",
      validation: "Please complete name, email, inquiry type, and message.",
      success: "✅ Thanks. We received your inquiry and will contact you soon.",
      error: "❌ We couldn't send it. Please try again in a few minutes.",
      submitError: "The form could not be submitted",
      placeholders: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        company: "Company / Organization",
        message: "Tell us about your opportunity, goal, or request",
      },
      reasonOptions: [
        "Sponsorship / brand partnership",
        "Press / Media",
        "Event activation",
        "Strategic partnership",
        "Content / Production",
        "General inquiry",
      ],
      sending: "Sending...",
      submit: "Send inquiry",
    },
  },
};

function createContactForm(lang) {
  const activeLang = lang === "en" ? "en" : "es";
  return {
    name: "",
    email: "",
    phone: "",
    company: "",
    reason: homeCopy[activeLang].contact.reasonOptions[0],
    message: "",
  };
}

export default function HomeV2() {
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "es";
  const copy = homeCopy[lang];
  const [contactForm, setContactForm] = useState(() => createContactForm(lang));
  const [contactSubmitting, setContactSubmitting] = useState(false);
  const [contactMessage, setContactMessage] = useState("");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = copy.meta.title;

    const setMeta = (name, content, isProperty = false) => {
      const selector = isProperty ? `meta[property='${name}']` : `meta[name='${name}']`;
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        if (isProperty) tag.setAttribute("property", name);
        else tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("description", copy.meta.description);
    setMeta("keywords", copy.meta.keywords);
    setMeta("og:title", copy.meta.title, true);
    setMeta("og:description", copy.meta.ogDescription, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://www.puertoricoesportleague.com/", true);
    setMeta("og:image", "https://www.puertoricoesportleague.com/logo.png", true);
    setMeta("og:locale", copy.meta.locale, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", copy.meta.title);
    setMeta("twitter:description", copy.meta.ogDescription);
    setMeta("twitter:image", "https://www.puertoricoesportleague.com/logo.png");

    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://www.puertoricoesportleague.com/");

    const schemaId = "prel-home-schema";
    let schemaTag = document.getElementById(schemaId);
    if (!schemaTag) {
      schemaTag = document.createElement("script");
      schemaTag.type = "application/ld+json";
      schemaTag.id = schemaId;
      document.head.appendChild(schemaTag);
    }
    schemaTag.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.puertoricoesportleague.com/#organization",
          name: "Puerto Rico Esports League",
          alternateName: "PREL",
          url: "https://www.puertoricoesportleague.com",
          logo: "https://www.puertoricoesportleague.com/logo.png",
          description: copy.meta.organizationDescription,
          email: "info@puertoricoesportleague.com",
          telephone: "+1-787-918-7979",
          sameAs: [
            "https://www.instagram.com/puertoricoesportsleague",
            "https://www.facebook.com/puertoricoesportsleague",
            "https://x.com/presportsleague",
            "https://www.youtube.com/@puertoricoesportsleague",
          ],
          address: {
            "@type": "PostalAddress",
            addressCountry: "PR",
            addressRegion: "Puerto Rico",
          },
          areaServed: ["Puerto Rico", "United States", "Latin America"],
        },
        {
          "@type": "WebSite",
          "@id": "https://www.puertoricoesportleague.com/#website",
          name: "Puerto Rico Esports League",
          url: "https://www.puertoricoesportleague.com",
          inLanguage: ["es", "en"],
          publisher: {
            "@id": "https://www.puertoricoesportleague.com/#organization",
          },
        },
        {
          "@type": "WebPage",
          "@id": "https://www.puertoricoesportleague.com/#webpage",
          url: "https://www.puertoricoesportleague.com/",
          name: copy.meta.webpageName,
          isPartOf: {
            "@id": "https://www.puertoricoesportleague.com/#website",
          },
          about: {
            "@id": "https://www.puertoricoesportleague.com/#organization",
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://www.puertoricoesportleague.com/logo.png",
          },
          dateModified: new Date().toISOString(),
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.puertoricoesportleague.com/#faq",
          mainEntity: copy.faq.items.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.a,
            },
          })),
        },
      ],
    });
  }, [copy, lang]);

  useEffect(() => {
    setContactForm((prev) => {
      const nextOptions = copy.contact.reasonOptions;
      const prevOptions = homeCopy[lang === "en" ? "es" : "en"].contact.reasonOptions;
      const currentReason = prev.reason;
      const nextReason = nextOptions.includes(currentReason)
        ? currentReason
        : prevOptions.includes(currentReason)
          ? nextOptions[prevOptions.indexOf(currentReason)] || nextOptions[0]
          : nextOptions[0];

      return { ...prev, reason: nextReason };
    });
  }, [copy.contact.reasonOptions, lang]);

  function updateContactField(key, value) {
    setContactForm((prev) => ({ ...prev, [key]: value }));
  }

  async function submitContact(e) {
    e.preventDefault();
    setContactMessage("");

    if (!contactForm.name || !contactForm.email || !contactForm.reason || !contactForm.message) {
      setContactMessage(copy.contact.validation);
      return;
    }

    setContactSubmitting(true);
    try {
      const response = await fetch("/api/contact-commercial", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(contactForm),
      });

      if (!response.ok) {
        const detail = await response.text();
        throw new Error(detail || copy.contact.submitError);
      }

      setContactMessage(copy.contact.success);
      setContactForm(createContactForm(lang));
    } catch (error) {
      setContactMessage(copy.contact.error);
    } finally {
      setContactSubmitting(false);
    }
  }

  return (
    <div className="bg-[#06070A] text-[#F5F7FF] min-h-screen selection:bg-cyan-400 selection:text-black scroll-smooth">
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_55%_at_80%_20%,rgba(0,42,143,0.20)_0%,transparent_65%),radial-gradient(ellipse_55%_60%_at_10%_80%,rgba(206,17,38,0.12)_0%,transparent_60%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.012)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.012)_1px,transparent_1px)] bg-[size:60px_60px]" />
      </div>

      <SiteHeader current="/" />

      <section id="inicio" className="max-w-[1500px] mx-auto px-6 xl:px-8 pt-10 pb-14 relative">
        <div className="relative overflow-hidden border border-white/10 min-h-[460px] md:min-h-[620px]">
          <img
            src="/logo.png"
            alt="Puerto Rico Esports League Hero"
            className="absolute inset-0 w-full h-full object-cover md:hidden"
            loading="eager"
            decoding="async"
          />
          <video
            className="absolute inset-0 w-full h-full object-cover hidden md:block"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            poster="/logo.png"
          >
            <source src="/hero-video-optimized.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-r from-[#06070A]/90 via-[#06070A]/70 to-[#06070A]/55" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#06070A]/75 to-transparent" />

          <div className="relative z-10 px-5 sm:px-6 md:px-10 py-10 md:py-14">
            <img src="/logo.png" alt="PR Esports League Logo" className="absolute right-4 top-4 h-14 md:right-6 md:top-6 md:h-20 opacity-30" />
            <p className="text-[#F5C842] mb-4 tracking-[0.22em] sm:tracking-[0.30em] uppercase text-[10px] sm:text-[11px] pr-16 sm:pr-20">{copy.hero.eyebrow}</p>
            <h1 className="text-[2rem] sm:text-5xl md:text-6xl xl:text-7xl font-black leading-[1.02] md:leading-[0.94] max-w-6xl uppercase pr-10 sm:pr-20 md:pr-0 text-balance">
              {copy.hero.title}
            </h1>
            <p className="text-slate-200 mt-6 text-base sm:text-lg max-w-3xl pr-4 sm:pr-0">
              {copy.hero.body}
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href="#contenido" className="px-5 py-3 rounded-xl bg-cyan-400 text-black font-semibold hover:brightness-110 transition">
                {copy.hero.ctaContent}
              </a>
              <a href="/partners" className="px-5 py-3 rounded-xl border border-cyan-300/40 text-cyan-300 hover:bg-cyan-400/10 transition">
                {copy.hero.ctaPartners}
              </a>
              <a href="/quienes-somos" className="px-5 py-3 rounded-xl border border-white/15 text-white hover:bg-white/5 transition">
                {copy.hero.ctaAbout}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <div className="mb-6 max-w-5xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.snapshot.eyebrow}</p>
          <h2 className="text-2xl md:text-3xl font-black uppercase mt-2">{copy.snapshot.title}</h2>
          <p className="text-slate-200 mt-3 leading-relaxed text-lg">
            <strong>{copy.snapshot.intro}</strong>
          </p>
          <p className="text-slate-300 mt-3 leading-relaxed">
            {copy.snapshot.body}
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 border border-white/10 bg-[#121826]">
          {copy.snapshot.metrics.map((item) => (
            <article key={item.label} className="p-5 md:p-7 border-r border-b lg:border-b-0 border-white/10 last:border-r-0 hover:bg-white/[0.03] transition">
              <p className="text-3xl md:text-4xl font-black text-white">{item.value}</p>
              <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400 mt-2">{item.label}</p>
            </article>
          ))}
        </div>
        <p className="text-sm text-slate-400 mt-3 max-w-4xl">
          {copy.snapshot.note}
        </p>
      </section>

      <section id="eventos" className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <div className="flex items-end justify-between mb-6 gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.events.eyebrow}</p>
            <h2 className="text-3xl font-black uppercase">{copy.events.title}</h2>
          </div>
          <a href="/eventos" className="text-cyan-300 text-sm hover:underline">{copy.events.all}</a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {copy.events.items.map((event) => {
            return (
              <article key={event.slug} className="bg-[#151A23] border border-white/10 p-5 hover:border-[#CE1126]/40 transition relative overflow-hidden group min-h-[250px] flex flex-col">
                <h3 className="text-xl font-semibold mt-4">{event.title}</h3>
                <p className="text-slate-300 mt-2">{event.date} · {event.game}</p>
                <p className="text-slate-400 text-sm mt-1">{event.venue}</p>
                {event.logo ? (
                  <div className="hidden md:flex flex-1 items-center justify-center py-6 pointer-events-none">
                    <img
                      src={event.logo}
                      alt={event.logoAlt || event.title}
                      className={event.logoClassName || "h-12 object-contain opacity-90"}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ) : (
                  <div className="hidden md:block flex-1" />
                )}
                <a
                  href={event.href || "#contacto"}
                  target={event.href?.startsWith("http") ? "_blank" : undefined}
                  rel={event.href?.startsWith("http") ? "noreferrer" : undefined}
                  className="mt-auto block text-center w-full py-2.5 rounded-lg bg-gradient-to-r from-violet-500 to-pink-500 font-semibold hover:opacity-95 transition"
                >
                  {copy.events.details}
                </a>
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#CE1126] scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100" />
              </article>
            );
          })}
        </div>
      </section>

      <section id="contenido" className="w-full pb-20">
        <div className="max-w-[1700px] mx-auto px-6 xl:px-8">
          <div className="flex items-end justify-between mb-6 gap-4">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.content.eyebrow}</p>
              <h3 className="text-2xl font-black uppercase">{copy.content.title}</h3>
            </div>
            <span className="text-slate-400 text-sm">{copy.content.caption}</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {featuredVideos.map((video) => (
              <article key={video.id} className="overflow-hidden border border-white/10 bg-[#111722] hover:border-[#CE1126]/40 transition rounded-[20px]">
                <div className="aspect-video">
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
                <p className="text-xs md:text-sm text-slate-300 p-3">{video.title}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full pb-20">
        <div className="max-w-[1700px] mx-auto px-6 xl:px-8">
          <div className="border border-white/10 bg-[#111722] p-6 md:p-8 rounded-[24px]">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-5">
              <h3 className="text-2xl font-bold">{copy.show.title}</h3>
              <a
                href="https://wipr.pr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={copy.show.ctaAria}
                title="Sitio oficial WIPR"
                className="text-cyan-300 text-sm hover:underline"
              >
                {copy.show.cta}
              </a>
            </div>
            <p className="text-slate-300 text-sm mb-4">{copy.show.body}</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {tvShowVideos.map((video) => (
                <article key={video.id} className="rounded-xl overflow-hidden border border-white/10 bg-[#0f1420]">
                  <div className="aspect-video">
                    <iframe
                      className="w-full h-full"
                      src={`https://www.youtube.com/embed/${video.id}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <p className="text-xs md:text-sm text-slate-300 p-3">{video.title}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full pb-20">
        <div className="max-w-[1700px] mx-auto px-6 xl:px-8">
          <div className="flex items-end justify-between mb-6 gap-4">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.gallery.eyebrow}</p>
              <h3 className="text-2xl font-black uppercase">{copy.gallery.title}</h3>
            </div>
            <span className="text-slate-400 text-sm">{copy.gallery.caption}</span>
          </div>
          <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2">
            {copy.gallery.items.map((shot) => (
              <article key={shot.src} className="min-w-[78%] md:min-w-[46%] lg:min-w-[32%] snap-start overflow-hidden border border-white/10 bg-[#111722] hover:border-[#CE1126]/40 transition rounded-[20px]">
                <img src={shot.src} alt={shot.title} className="w-full h-56 md:h-72 object-cover" style={shot.objectPosition ? { objectPosition: shot.objectPosition } : undefined} loading="lazy" decoding="async" />
                <p className="text-xs md:text-sm text-slate-300 p-3">{shot.title}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="impacto" className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <div className="mb-6">
          <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.impact.eyebrow}</p>
          <h2 className="text-2xl font-black uppercase">{copy.impact.title}</h2>
        </div>
        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          <article className="border border-white/10 bg-[#111722] p-7 rounded-[24px]">
            <h3 className="text-2xl font-bold mb-4">{copy.impact.ecosystemTitle}</h3>
            <p className="text-slate-300 mb-5">{copy.impact.ecosystemBody}</p>
            <ul className="space-y-3 text-slate-200">
              {copy.impact.bullets.map((item) => (
                <li key={item}>• {item}</li>
              ))}
            </ul>
          </article>

          <article className="border border-white/10 bg-[#111722] p-7 rounded-[24px]">
            <h3 className="text-2xl font-bold mb-4">{copy.impact.pastTitle}</h3>
            <div className="space-y-4">
              {copy.impact.highlights.map((item) => (
                <div key={item.title} className="border border-white/10 p-4 hover:border-[#CE1126]/40 transition">
                  <p className="font-semibold">{item.title}</p>
                  <p className="text-slate-300 text-sm mt-1">{item.desc}</p>
                </div>
              ))}
            </div>
          </article>
        </div>
      </section>

      <section id="affiliations" className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126] mb-2">{copy.affiliations.eyebrow}</p>
        <div className="mb-6 max-w-4xl">
          <h2 className="text-2xl font-black uppercase">{copy.affiliations.title}</h2>
          <p className="text-slate-300 mt-3 leading-relaxed">{copy.affiliations.body}</p>
        </div>
        <div className="border border-white/10 bg-[#111722] p-3 md:p-4 rounded-[24px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {affiliationLogos.map((logo) => (
              <div
                key={logo.name}
                className="rounded-2xl border border-white/10 bg-[#0F1220] px-6 py-7 md:px-8 md:py-8"
                title={logo.name}
              >
                <div className="h-24 md:h-28 rounded-2xl border border-white/10 bg-white flex items-center justify-center px-7 md:px-8 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]">
                  <img
                    src={logo.src}
                    alt={logo.name}
                    className={`${logo.className} w-auto object-contain ${logo.imageClassName || "opacity-100"}`}
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      const fallback = e.currentTarget.nextElementSibling;
                      if (fallback) fallback.style.display = "flex";
                    }}
                  />
                  <span className="hidden text-center text-sm font-semibold tracking-[0.06em] uppercase text-slate-900">
                    {logo.fallback}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="partners" className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126] mb-2">{copy.partners.eyebrow}</p>
        <div className="mb-6 flex items-end justify-between gap-4">
          <h2 className="text-2xl font-black uppercase"><a href="/partners" className="hover:text-cyan-300 transition">{copy.partners.title}</a></h2>
          <a href="/partners" className="text-cyan-300 text-sm hover:underline">{copy.partners.cta}</a>
        </div>
        <div className="border border-white/10 bg-[#111722] p-3 md:p-4 rounded-[24px]">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
            {partnerLogos.map((logo) => (
              <div key={logo.src} className="h-20 border border-white/10 bg-[#121826] flex items-center justify-center p-3 hover:border-[#CE1126]/40 transition">
                <img src={logo.src} alt={logo.alt} className={`${logo.className} w-auto object-contain opacity-95`} loading="lazy" decoding="async" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <div className="border border-white/10 bg-[#111722] p-7 md:p-8 rounded-[24px]">
          <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126] mb-2">{copy.faq.eyebrow}</p>
          <h2 className="text-2xl font-black uppercase">{copy.faq.title}</h2>
          <div className="mt-6 grid gap-4 md:grid-cols-2">
            {copy.faq.items.map((item) => (
              <article key={item.q} className="border border-white/10 bg-[#0F1220] p-5">
                <h3 className="text-lg font-bold">{item.q}</h3>
                <p className="mt-3 text-slate-300 leading-relaxed">{item.a}</p>
              </article>
            ))}
          </div>
          <div className="mt-5">
            <a href="/faq" className="text-cyan-300 text-sm hover:underline">{copy.faq.cta}</a>
          </div>
        </div>
      </section>

      <section id="registro" className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-24">
        <div className="border border-white/15 bg-[#CE1126] p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 relative overflow-hidden rounded-[28px]">
          <div className="absolute inset-0 bg-[repeating-linear-gradient(-45deg,rgba(0,0,0,0.08)_0px,rgba(0,0,0,0.08)_1px,transparent_1px,transparent_18px)]" />
          <div className="relative z-10">
            <p className="text-white/80 text-xs tracking-[0.22em] uppercase">{copy.nextStep.eyebrow}</p>
            <h3 className="text-2xl md:text-4xl font-black mt-2 uppercase leading-tight">{copy.nextStep.title}</h3>
            <p className="text-white/85 mt-3">{copy.nextStep.body}</p>
          </div>
          <a href="/contacto" className="relative z-10 px-6 py-3 bg-white text-[#CE1126] font-semibold whitespace-nowrap text-center hover:bg-black hover:text-white transition">
            {copy.nextStep.cta}
          </a>
        </div>
      </section>

      <section id="contacto" className="max-w-[1500px] mx-auto px-6 xl:px-8 pb-16">
        <div className="border border-white/10 bg-[#111722] p-7 md:p-8 rounded-[24px]">
          <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126] mb-2">{copy.contact.eyebrow}</p>
          <h3 className="text-2xl font-black uppercase">{copy.contact.title}</h3>
          <p className="text-slate-300 mt-2">{copy.contact.body}</p>

          <form onSubmit={submitContact} className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              required
              value={contactForm.name}
              onChange={(e) => updateContactField("name", e.target.value)}
              placeholder={copy.contact.placeholders.name}
              className="w-full rounded-lg bg-[#0b1019] border border-white/15 px-3 py-2"
            />
            <input
              required
              type="email"
              value={contactForm.email}
              onChange={(e) => updateContactField("email", e.target.value)}
              placeholder={copy.contact.placeholders.email}
              className="w-full rounded-lg bg-[#0b1019] border border-white/15 px-3 py-2"
            />
            <input
              value={contactForm.phone}
              onChange={(e) => updateContactField("phone", e.target.value)}
              placeholder={copy.contact.placeholders.phone}
              className="w-full rounded-lg bg-[#0b1019] border border-white/15 px-3 py-2"
            />
            <input
              value={contactForm.company}
              onChange={(e) => updateContactField("company", e.target.value)}
              placeholder={copy.contact.placeholders.company}
              className="w-full rounded-lg bg-[#0b1019] border border-white/15 px-3 py-2"
            />
            <select
              required
              value={contactForm.reason}
              onChange={(e) => updateContactField("reason", e.target.value)}
              className="w-full rounded-lg bg-[#0b1019] border border-white/15 px-3 py-2"
            >
              {copy.contact.reasonOptions.map((option) => (
                <option key={option}>{option}</option>
              ))}
            </select>
            <textarea
              required
              value={contactForm.message}
              onChange={(e) => updateContactField("message", e.target.value)}
              placeholder={copy.contact.placeholders.message}
              rows={4}
              className="md:col-span-2 w-full rounded-lg bg-[#0b1019] border border-white/15 px-3 py-2"
            />

            <button
              type="submit"
              disabled={contactSubmitting}
              className="md:col-span-2 rounded-lg bg-cyan-400 text-black font-semibold px-3 py-2 disabled:opacity-60"
            >
              {contactSubmitting ? copy.contact.sending : copy.contact.submit}
            </button>
          </form>

          {contactMessage ? <p className="text-sm text-slate-300 mt-3">{contactMessage}</p> : null}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
